import {
  BonificoExternalSettlementDTO,
  BonificoOrderDTO,
  ExternalOrderPaymentType,
  externalSettlementGatewayLabel,
} from "../../ProductService/BonificoOrder/BonificoOrderDTO.ts";

function describeExternalSettlementRecording(
  settlement: BonificoExternalSettlementDTO,
): string {
  const gatewayLabel = externalSettlementGatewayLabel(settlement);
  const order = `dell'ordine ${gatewayLabel} ${settlement.externalOrderId}`;
  const recording =
    settlement.originalPaymentType === ExternalOrderPaymentType.OneTime
      ? `L'integrazione verrà registrata come ulteriore vendita ${order} pagata con bonifico`
      : `Il saldo verrà registrato come rata ${order} pagata con bonifico`;
  return `${recording}: fattura su Fatture in Cloud e transazione su BigQuery alla data di valuta. Su ${gatewayLabel} non viene aggiornato nulla.`;
}

export function describeInvoiceIssue(order: BonificoOrderDTO): string {
  if (order.installmentsSettlement)
    return "Il saldo verrà registrato come rata dell'ordine Stripe pagata con bonifico: fattura su Fatture in Cloud e transazione su BigQuery alla data di valuta, e il pagamento comparirà nello storico rate dell'ordine Stripe.";
  if (order.externalSettlement)
    return describeExternalSettlementRecording(order.externalSettlement);
  return "Verranno emessi la fattura su Fatture in Cloud e la transazione su BigQuery, entrambe alla data di valuta.";
}
